import React, { useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import emailjs from "@emailjs/browser";
import { servicesContent4 } from "../element/SliderContent";

const Footer = () => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();
    //emailjs.sendForm('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', form.current, 'YOUR_USER_ID')
    emailjs
      .sendForm(
        "gmail",
        "YOUR_TEMPLATE_ID",
        e.target,
        "d9b2e0f5fc72cb94792110e8ff2028f3-us16"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  };

  const history = useHistory();

  const handleNavigation = (sectionId) => {
    if (window.location.pathname !== "/") {
      // If not on the home page, redirect to the home page
      history.push("/");
      // Use a timeout to wait for the page to load before scrolling
      setTimeout(() => {
        document
          .getElementById(sectionId)
          ?.scrollIntoView({ behavior: "smooth" });
      }, 100); // Adjust the timeout if needed
    } else {
      // If already on the home page, just scroll to the section
      document
        .getElementById(sectionId)
        ?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <footer className="site-footer style1">
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-md-4 col-sm-6">
                <div className="widget widget_about">
                  <h4 className="footer-title">About Industry</h4>
                  <p>
                    Cleanliness is essential to professionalism and productivity
                    in commercial spaces. We provide comprehensive office
                    cleaning, covering workstations to high-traffic common
                    areas. Our services include regular cleaning, carpet and
                    upholstery care, and restroom sanitization, all scheduled
                    for minimal disruption to your business operations. A
                    polished, professional atmosphere awaits every day.
                  </p>
                  <div className="footer-description">
                    <div className="footer-icon">
                      {/* <span className="icon-sm"> */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="white"
                      >
                        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z" />
                      </svg>

                      {/* </span>{" "} */}
                    </div>
                    <div className="footer-item">
                      <span> 6308 31 Bourton Road Merrimac 4226</span>
                    </div>
                  </div>
                  <div className="footer-description">
                    <div className="footer-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="white"
                       
                      >
                        <path d="M2 6a2 2 0 012-2h16a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6zm2 0l8 5 8-5H4zm0 2v8h16V8l-8 5-8-5z" />
                      </svg>
                    </div>
                    <div className="footer-item">
                      <span> info@kangarooshine.com.au</span>
                    </div>
                  </div>
                  <div className="footer-description">
                    <div className="footer-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="white"
                       
                      >
                        <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1.5 1.5 0 011.61-.33c1.12.45 2.33.69 3.58.69a1.5 1.5 0 011.5 1.5v3.29a1.5 1.5 0 01-1.29 1.49C14.56 22.34 2.66 10.44 1.07 3.29A1.5 1.5 0 012.56 2H5.85a1.5 1.5 0 011.5 1.5c0 1.25.24 2.46.69 3.58.23.58.09 1.25-.33 1.61l-2.2 2.2z" />
                      </svg>
                    </div>
                    <div className="footer-item">
                      <span> 0424 888 804</span>
                    </div>
                  </div>

                  {/* <Link to={"/about-2"} className="readmore">
                    Read More
                  </Link> */}
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="widget">
                  <h4 className="footer-title">Our Services</h4>
                  <ul className="footer-list">
                    {servicesContent4.map((item, serviceIndex) => {
                      return <li>{item.serviceName}</li>;
                    })}
                  </ul>
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="widget">
                  <h4 className="footer-title">Our Industries</h4>
                  <ul className="footer-list">
                    <li>Office & Commercial</li>
                    <li>Healthcare</li>
                    <li>Industrial & Manufacturing</li>
                    <li>Education</li>
                    <li>Hospitality & Accommodation</li>
                    <li>Retail Stores & Shopping Centres</li>
                  </ul>
                </div>
              </div>
              <div className="col-md-2 col-sm-6">
                <div className="widget">
                  <h4 className="footer-title">Quik Links</h4>
                  <ul className="footer-list">
                    <li>
                      <Link onClick={() => handleNavigation("about")} to={"#"}>
                        About Us
                      </Link>
                    </li>

                    <li>
                      <Link
                        onClick={() => handleNavigation("services")}
                        to={"#"}
                      >
                        Services
                      </Link>
                    </li>
                    {/* <li>
                      <Link onClick={() => handleNavigation("blogs")} to={"#"}>
                        Blogs
                      </Link>
                    </li> */}
                    {/* <li>
                      <Link onClick={() => handleNavigation("latest")} to={"#"}>
                        Latest Projects
                      </Link>
                    </li> */}
                    {/* <li>
                      <Link
                        onClick={() => handleNavigation("testimonials")}
                        to={"#"}
                      >
                        Testimonials
                      </Link>
                    </li> */}
                    <li>
                      <Link
                        onClick={() => handleNavigation("industries")}
                        to={"#"}
                      >
                        Industries
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() => {
                          window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "auto"
                          });
                        }}
                        to={"/contact"}
                      >
                        Contact Us
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              {/* <div className="col-md-4 col-sm-12">
                <div className="widget widget_subscribe">
                  <h4 className="footer-title">Usefull Link</h4>
                  <p>
                    If you have any questions. Subscribe to our newsletter to
                    get our latest products.
                  </p>
                  <form className="dzSubscribe" ref={form} onSubmit={sendEmail}>
                    <div className="dzSubscribeMsg"></div>
                    <div className="form-group">
                      <div className="input-group">
                        <input
                          name="dzEmail"
                          required="required"
                          type="email"
                          className="form-control"
                          placeholder="Your Email Address"
                        />
                        <div className="input-group-addon">
                          <button
                            name="submit"
                            value="Submit"
                            type="submit"
                            className="site-button fa fa-paper-plane-o"
                          ></button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div> */}
            </div>
          </div>
        </div>

        <div className="footer-bottom footer-line">
          <div className="container">
            <div className="footer-bottom-in">
              <div className="footer-bottom-logo">
                <Link to={"/"}>
                  <img src={require("../../images/logo.png")} alt="" />
                </Link>
              </div>

              <div className="footer-bottom-social">
                <ul className="dlab-social-icon dez-border">
                  <li>
                    <Link
                      className=" circle fab fa-facebook-f"
                      to={"/#"}
                    ></Link>
                  </li>

                  <li>
                    <Link className=" fab fa-instagram" to={"/#"}></Link>
                  </li>
                  <li>
                    <Link className="fab fa-youtube" to={"/#"}></Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-new">
          Designed By{" "}
          <a
            href="https://www.infinitixx.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={require("../../images/infi.png")} alt="" />
          </a>
        </div>
      </footer>
    </>
  );
};

export default Footer;
